import script from "./UserLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./UserLogin.vue?vue&type=script&setup=true&lang=js"

import "./UserLogin.vue?vue&type=style&index=0&id=07cfb845&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../Users/kmg/Documents/VS Code/Classwork/poker-session-tracker-vue3/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07cfb845"]])

export default __exports__